"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarEditComplectation = void 0;
var react_1 = __importStar(require("react"));
var icons_1 = require("@ant-design/icons");
var messageContext_1 = require("../../hoc/messageContext");
var useCarEditComplectation_1 = require("../../hook/useCarEditComplectation");
var form_1 = __importDefault(require("antd/es/form"));
var select_1 = __importDefault(require("antd/es/select"));
var button_1 = __importDefault(require("antd/es/button"));
var typography_1 = __importDefault(require("antd/es/typography"));
var space_1 = __importDefault(require("antd/es/space"));
var popconfirm_1 = __importDefault(require("antd/es/popconfirm"));
var table_1 = __importDefault(require("antd/es/table"));
var Title = typography_1.default.Title;
var CarEditComplectation = function () {
    var _a = (0, useCarEditComplectation_1.useCarEditComplectation)(), complectation = _a.complectation, carId = _a.carId;
    var form = form_1.default.useForm()[0];
    var _b = (0, react_1.useState)([]), flatData = _b[0], setFlatData = _b[1];
    var _c = (0, messageContext_1.useMessageContext)(), showSuccess = _c.showSuccess, showError = _c.showError;
    react_1.default.useEffect(function () {
        if (complectation === null || complectation === void 0 ? void 0 : complectation.extras.length) {
            setFlatData(complectation.extras.map(function (item) { return ({
                key: item.extra_id,
                category: item.category_name,
                feature: item.extra_name_name,
            }); }));
        }
    }, [complectation]);
    if (!complectation)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var handleDelete = function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/extras/").concat(key), {
                        method: 'DELETE',
                        body: JSON.stringify({ extra_id: key }),
                    })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess('Характеристика успешно удалена');
                    }
                    else {
                        showError('Ошибка при удалении характеристики');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var columns = [
        {
            title: 'Категория',
            dataIndex: 'category',
            key: 'category',
            width: '30%',
            sorter: function (a, b) { return a.category.localeCompare(b.category); },
            render: function (text) { return react_1.default.createElement("strong", null, text); },
        },
        {
            title: 'Характеристика',
            dataIndex: 'feature',
            key: 'feature',
            width: '50%',
        },
        {
            title: 'Действия',
            key: 'action',
            width: '20%',
            render: function (_, record) { return (react_1.default.createElement(space_1.default, { size: "middle" },
                react_1.default.createElement(popconfirm_1.default, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0443?", description: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0443?", onConfirm: function () { return handleDelete(record.key); }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" },
                    react_1.default.createElement(button_1.default, { type: "link", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null) }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))); },
        },
    ];
    var onFinish = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/extras"), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ extra: __assign(__assign({}, values), { car_id: carId }) }),
                    })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess('Характеристика успешно добавлена');
                    }
                    else {
                        showError('Ошибка при добавлении характеристики');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Title, { level: 1, style: { marginBottom: '20px' } }, "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044F"),
        react_1.default.createElement(table_1.default, { columns: columns, dataSource: flatData.map(function (data) {
                return __assign(__assign({}, data), { key: data.key });
            }), bordered: true, size: "middle", pagination: {
                pageSize: 10,
                showSizeChanger: false,
                showTotal: function (total) { return "\u0412\u0441\u0435\u0433\u043E ".concat(total, " \u0437\u0430\u043F\u0438\u0441\u0435\u0439"); },
            } }),
        react_1.default.createElement(Title, { level: 3, style: { marginTop: '20px' } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0443"),
        react_1.default.createElement(form_1.default, { form: form, layout: "inline", onFinish: onFinish },
            react_1.default.createElement(form_1.default.Item, { name: "category_id", rules: [{ required: true, message: 'Выберите категорию' }] },
                react_1.default.createElement(select_1.default, { placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044E", style: { width: 200 }, showSearch: true, optionFilterProp: "children" }, complectation.all_categories.map(function (category) { return (react_1.default.createElement(select_1.default.Option, { key: category.id, value: category.id }, category.name)); }))),
            react_1.default.createElement(form_1.default.Item, { name: "extra_name_id", rules: [{ required: true, message: 'Выберите характеристику' }] },
                react_1.default.createElement(select_1.default, { placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0443", style: { width: 200 }, showSearch: true, optionFilterProp: "children" }, complectation.all_extra_names
                    .sort(function (a, b) { return a.name.localeCompare(b.name); })
                    .map(function (extra) { return (react_1.default.createElement(select_1.default.Option, { key: extra.id, value: extra.id }, extra.name)); }))),
            react_1.default.createElement(form_1.default.Item, null,
                react_1.default.createElement(button_1.default, { type: "primary", htmlType: "submit" }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C")))));
};
exports.CarEditComplectation = CarEditComplectation;
